import React, { FC, useState } from 'react';
import styled, { css } from 'styled-components';
import { typography } from 'src/config/typography';
import { colors } from 'src/config/colors';
import { below, media, widthBreakpoints } from 'src/config/breakpoints';
import { TooltipContent } from 'src/common/components/Tooltip/TooltipContent';
import { ClickAwayListener } from '@material-ui/core';
import { Tooltip } from 'src/common/components/Tooltip';
import InfoFullIcon from 'src/assets/icons/InfoFullIcon';
import { CleanButton } from 'src/common/components/Button';
import { MediaQuery } from 'src/common/migration/MediaQuery';

const CourseListingSectionTitle = styled.div`
  font-family: ${typography.fontFamilyHeaders};
  font-size: 1.5rem;
  line-height: 1.875rem;
  color: ${colors.blue};
  display: flex;
  gap: 10px;
  align-items: center;
`;

const DescriptionHint = styled.div`
  display: none;

  ${media.w.min.px992(css`
    display: block;
    font-family: ${typography.fontFamilyDefault};
    font-size: 0.75rem;
    line-height: 1rem;
    color: ${colors.blue};
  `)}
`;

const CourseListingHeaderContainer = styled.div`
  display: flex;
  gap: 0.625rem;
  ${media.w.min.px768(css`
    flex-direction: column;
    gap: 0.3125rem;
  `)}

  ${media.w.between.px768.px992(css`
    margin-left: 1.5rem;
  `)}
`;

const StyledTooltip = styled(Tooltip)`
  max-width: 23.5rem;
`;

const TooltipButton = styled(CleanButton)`
  padding: 0;
`;

export interface CourseListingHeaderProps {
  title: string;
  description?: string;
}

export const CourseListingSectionHeader: FC<CourseListingHeaderProps> = ({
  title,
  description,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <CourseListingHeaderContainer>
      <CourseListingSectionTitle>
        {title}{' '}
        <MediaQuery maxWidth={below(widthBreakpoints.px992)}>
          <ClickAwayListener onClickAway={() => setShowTooltip(false)}>
            <div>
              <StyledTooltip
                arrow
                disableFocusListener
                disableHoverListener
                disableTouchListener
                open={showTooltip}
                placement="top-start"
                title={
                  <TooltipContent onClose={() => setShowTooltip(false)}>
                    {description}
                  </TooltipContent>
                }
              >
                <TooltipButton onClick={() => setShowTooltip(true)}>
                  <InfoFullIcon size={18} />
                </TooltipButton>
              </StyledTooltip>
            </div>
          </ClickAwayListener>
        </MediaQuery>
      </CourseListingSectionTitle>
      <DescriptionHint>{description}</DescriptionHint>
    </CourseListingHeaderContainer>
  );
};
